module.exports = __webpack_public_path__ + "static/img/delete.3cd34de0.png";